import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../root/root-types';

const BEAT_PLAN_FEATURE_KEY = 'beatPlan';

export interface BeatPlanState {
  currentBeat: {
    beatPlanScheduleRouteId?: string;
    beatPlanScheduleCustomerId?: string;
    customerId?: string;
  };
}

const initialState: BeatPlanState = {
  currentBeat: {},
};

export const beatPlanSlice = createSlice({
  name: BEAT_PLAN_FEATURE_KEY,
  initialState,
  reducers: {
    updateCurrentBeat(
      state,
      action: PayloadAction<{
        beatPlanScheduleRouteId?: string;
        beatPlanScheduleCustomerId?: string;
        customerId?: string;
      }>
    ) {
      state.currentBeat = action.payload;
    },
  },
});

export const { updateCurrentBeat } = beatPlanSlice.actions;

const getBeatPlanState = (state: RootState): BeatPlanState =>
  state[BEAT_PLAN_FEATURE_KEY];

export const getCurrentBeat = createSelector(
  getBeatPlanState,
  (state) => state.currentBeat
);
